const IDEMPOTENT_METHODS = new Set(['get', 'head']);

const stableStringify = (value) => {
  if (value == null) {
    return '';
  }
  if (typeof value !== 'object') {
    return String(value);
  }
  if (Array.isArray(value)) {
    return `[${value.map(stableStringify).join(',')}]`;
  }
  return `{${Object.keys(value).sort().map((key) => `${key}:${stableStringify(value[key])}`).join(',')}}`;
};

const headerValue = (headers, name) => {
  if (!headers) {
    return '';
  }
  if (typeof headers.get === 'function') {
    return headers.get(name) || headers.get(name.toLowerCase()) || '';
  }
  return headers[name] || headers[name.toLowerCase()] || '';
};

export const buildInFlightRequestKey = (config) => {
  const method = String(config?.method || 'get').toLowerCase();
  const url = `${config?.baseURL || ''}${config?.url || ''}`;
  return [
    method,
    url,
    stableStringify(config?.params),
    headerValue(config?.headers, 'Authorization'),
    headerValue(config?.headers, 'X-Store-Id'),
  ].join('|');
};

export const wrapAdapterWithInFlightGetDedup = (adapter) => {
  const pending = new Map();

  return (config) => {
    const method = String(config?.method || 'get').toLowerCase();
    if (!IDEMPOTENT_METHODS.has(method) || config?.skipInFlightDedup) {
      return adapter(config);
    }

    const key = buildInFlightRequestKey(config);
    const existing = pending.get(key);
    if (existing) {
      return existing;
    }

    const request = Promise.resolve(adapter(config)).finally(() => {
      pending.delete(key);
    });
    pending.set(key, request);
    return request;
  };
};
